import React, { useState } from 'react'
import {
    Stack,
    TextField,
    Typography,
    InputAdornment,
    useTheme,
    Menu,
    Button,
} from "@mui/material";
import FilterButtons from './FilterButtons';
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled, alpha } from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme, width }) => ({
    '& .MuiPaper-root': {
        borderRadius: 4,
        marginTop: 16,
        minWidth: width ||'12%',
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            '0px 3px 6px #00000029;',
        '& .MuiMenu-list': {
            padding: '0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function CheckboxFilter({ withSearch = true, headData, onChange }) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [noDataSearchList, setNoDataserachList] = useState(false);
    const handleDropDownClick = (event) => {
        setAnchorEl(event.currentTarget);
        setCheckList(headData?.filter?.selectValue || []);
    };

    const handleClose = () => {
        setSearch('')
        setAnchorEl(null);
    };

    const [search, setSearch] = useState('');
    const [checkboxLists, setCheckboxLists] = useState(headData?.filter?.filterList);

    const handleSearch = (event) => {
        const tempValue = event.target.value.trimStart();
        setSearch(tempValue);
        filterList(tempValue);
    };

    const [checkList, setCheckList] = useState([]);

    const handleChange = (event) => {
        if (event.target.checked === true) {
            setCheckList([...checkList, Number(event.target.value)]);
        } else {
            const selectedAcc = checkList.filter(a => {
                if (a === Number(event.target.value)) return false;
                return true;
            });

            setCheckList([...selectedAcc]);
        }
    };

    const filterList = (value) => {
        const allList = headData?.filter?.filterList;
        const comparearray = allList.filter((elem) => !checkList.find((id) => elem.id === id));
        const list = comparearray.filter(function (item) {
            return item?.label.toLowerCase().indexOf(value.toLowerCase()) !== -1; // returns true or false
        });
        if (list?.length === 0) {
            setNoDataserachList(true);
        } else {
            setNoDataserachList(false);
        }
        const check = headData?.filter?.filterList.filter((elem) => checkList.find((id) => elem.id === id));
        setCheckboxLists([...check, ...list]);
    }

    const handleSubmit = (btntype) => {
        const updateObj = headData;
        updateObj.filter.selectValue = btntype === 'Reset' || checkList.length === 0 ? null :  checkList || [];
        onChange({ ...updateObj });
        setSearch(null)
        setCheckboxLists(headData?.filter?.filterList);
        handleClose()
    };

    return (
        <>
            <Button
                style={{
                    background: headData?.filter?.selectValue ? theme.palette.primary.main : '',
                    color: headData?.filter?.selectValue ? theme.palette.background.main : '',
                }}
                className='!p-[0px] !min-w-[23px] !mr-[10px] !w-[23px] !h-[23px] ' onClick={(event) => {
                    handleDropDownClick(event);
                }}
            >
                <ArrowDropDownIcon />
            </Button>

            <StyledMenu
                id="filter-list-menu-checkBox"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                width = {headData?.width}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Stack className='!px-[6px] !py-[6px] !relative'>
                    {withSearch && headData?.filter  ? <Stack direction="row" spacing={1} className='!px-[6px] !py-[6px] !justify-around'>
                        <TextField
                            autoComplete='off'
                            className=''
                            id="search"
                            name="search"
                            value={search || ""}
                            onChange={handleSearch}
                            size="small"
                            sx={{
                                maxWidth: "139px",
                                minWidth: "139px",
                                height: '32px',
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 16
                                }
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment disablePointerEvents position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Stack> : null
                    }

                    <Stack className="!px-[6px] !pb-[0px] !py-[6px] max-h-[265px]  
                overflow-auto
                [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none'] ">
                        {checkboxLists?.map((checkbox, index) => (
                            <Stack className=''>
                                <FormControlLabel
                                    key={index + checkbox.label}
                                    labelPlacement="start"
                                    control={
                                        <Checkbox
                                            onChange={handleChange}
                                            value={checkbox?.id}
                                            checked={
                                                checkList.lastIndexOf(Number(checkbox?.id)) >= 0 ? true : false
                                            }
                                            name={checkbox.label}
                                            id={checkbox.id}
                                            color={"primary"}
                                            style={{ marginRight: '8px' }}
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    height: 12,
                                                    width: 12,
                                                },
                                            }}
                                        />
                                    }
                                    sx={{
                                        marginLeft: '0px',
                                        justifyContent: 'space-between'
                                    }}
                                    label={<Typography className='!text-[12px]'>{checkbox?.label || '-'}</Typography>}
                                />
                            </Stack>
                        ))}
                        {noDataSearchList ?
                            <Stack >
                                <Typography className='!text-[12px] !text-center !p-[16px] !font-medium'
                                    style={{
                                        color: 'rgb(112, 112, 112)'
                                    }}>
                                    Search Not Found
                                </Typography></Stack> : null}
                    </Stack>
                </Stack>
                <Stack style={{ borderTop: 'solid 0.01px #cecccc', background: theme.palette.background.main }}
                    direction="row" spacing={1} className='!px-[6px] !py-[8px] !justify-around !sticky !bottom-[0]'>
                    <FilterButtons name={`Reset`} onClick={(btnType) => { handleSubmit(btnType) }} />
                    <FilterButtons disabled={!(checkList.length > 0 || headData?.filter?.selectValue) } name={`Apply`} onClick={(btnType) => { handleSubmit(btnType) }} />
                </Stack>
            </StyledMenu >
        </>
    )
}
